/**
 * Telemetry bridge for non-React code (e.g., Axios interceptors).
 *
 * React components should use `useTelemetry()` hook instead.
 * This module re-exports the Shell framework's `telemetryClient`
 * so non-hook contexts can access telemetry without a second App Insights instance.
 */
import { telemetryClient } from '@/ShellWithStore';
import { SeverityLevel } from '@microsoft/applicationinsights-common';
import { EventType } from '@micro-frontend-react/employee-experience/lib/UsageTelemetry';
import { withCorrelation } from './utils';

export function trackEvent(name: string, properties?: Record<string, string>): void {
    telemetryClient?.trackEvent({ name }, withCorrelation(properties));
}

export function trackException(error: Error, properties?: Record<string, string>): void {
    telemetryClient?.trackException({ exception: error }, withCorrelation(properties));
}

export function trackTrace(
    message: string,
    severityLevel: SeverityLevel = SeverityLevel.Information,
    properties?: Record<string, string>,
): void {
    telemetryClient?.trackTrace(
        { message, severityLevel },
        withCorrelation(properties),
    );
}

export function trackPageView(name: string, properties?: Record<string, string>): void {
    telemetryClient?.trackPageView({
        name,
        properties: withCorrelation(properties),
        type: EventType.User,
        eventName: name,
    });
}
